import useAxios from '../../../library/axios'; 

import IBankPerson, {IBankPersonSearch} from '../model/BankPerson';

const _ = () => {

    const axios = useAxios();

    const saveBankPerson = async (bankPerson: IBankPerson)  =>       
        await (await axios.post('/crm/bankPerson/save', bankPerson)).data;   

    const getBankPerson = async (bankPersonID  : number ) : Promise<IBankPerson> => {        
        const {data} = (await axios.get(`/crm/bankPerson/getBankPerson/${bankPersonID}`));
        return await data;
        }
    
    const getBankPersonsList = async (criteria  : IBankPersonSearch ) : Promise<IBankPerson[]>  => {
        const {firstName, lastName,personNameNIC, phoneNumber ,birthYear, birthMonth} = criteria;
        const {data} = (await axios.get(`/crm/bankPerson/getBankPersonsList/?firstName=${firstName}&lastName=${lastName}&personNameNIC=${personNameNIC}&phoneNumber=${phoneNumber}&birthYear=${birthYear}&birthMonth=${birthMonth}`));
        return await data;
      }

    return {
        saveBankPerson,
        getBankPerson,

        getBankPersonsList      
    } 
}

export default _;